import React, { useState } from "react";
import { Dialog, Slide } from "@mui/material";
import { useHistory } from "react-router-dom";
import { TransitionProps } from "@mui/material/transitions";
import { UnauthorizeImage } from "../../../assets/images";
type AppProps = {
  open: boolean;
  setOpen: (data: boolean) => void;
  onPress: any;
};

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const UnAuthorizedFullpageModal = ({ open, setOpen, onPress }: AppProps) => {
  const history = useHistory();

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        onClose={() => handleClose()}
        TransitionComponent={Transition}
      >
        <div className="d-flex justify-content-center align-items-center flex-column p-3">
          <img src={UnauthorizeImage} alt="" style={{ height: "40vh" }} />
          <span className="mt-4 mb-3 unauthorize-title">
            You're not authorized to see this page.
          </span>
          <span className="unauthorize-sub-text">
            If you want to access this page then please contact us on{" "}
            <span className="text-danger">info@stco.co.in.</span>
          </span>
          <div>
            <span
              onClick={() => history.push("/")}
              className="btn btn-primary btn-err mt-3"
            >
              Go To Home
            </span>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default UnAuthorizedFullpageModal;
